// @flow
import styled, { css } from 'styled-components';
import { errorText, flamingo, daveGrey } from '../../colors';
import Input from '../../input';
/*::
  import type { FormElementThemeType } from '..';
*/
// interface StyledLabelProps {
//     focused: boolean;
//     error: boolean;
// }

var StyledCaption = styled.span.withConfig({
  displayName: "theme__StyledCaption",
  componentId: "sc-32oveo-0"
})(["margin-top:0.4rem;padding-left:1rem;font-size:1.2rem;"]);
var theme
/*: FormElementThemeType */
= {
  Main: styled.div.withConfig({
    displayName: "theme__Main",
    componentId: "sc-32oveo-1"
  })(["box-sizing:border-box;position:relative;margin-bottom:20px;"]),
  Label: styled.label.withConfig({
    displayName: "theme__Label",
    componentId: "sc-32oveo-2"
  })(["position:absolute;top:6px;left:1rem;z-index:2;transform:translateY(1.6rem);transition:all 0.2s ease-in;font-size:1.6rem;font-weight:200;margin-bottom:5px;color:", ";pointer-events:none;white-space:nowrap;width:90%;text-overflow:ellipsis;overflow:hidden;", ""], function (pr) {
    return pr.error ? errorText() : daveGrey();
  }, function (pr) {
    return pr.focused ? css(["transform:translateY(0);font-size:1.2rem;font-weight:300;color:", ";"], pr.error ? errorText() : flamingo()) : '';
  }),
  GroupLabel: styled.label.withConfig({
    displayName: "theme__GroupLabel",
    componentId: "sc-32oveo-3"
  })(["display:block;margin-bottom:1.2rem;font-size:1.4rem;font-weight:300;"]),
  Required: styled.span.withConfig({
    displayName: "theme__Required",
    componentId: "sc-32oveo-4"
  })(["display:inline-block;margin-left:0.2rem;font-weight:300;color:", ";"], flamingo()),
  Placeholder: styled(Input).withConfig({
    displayName: "theme__Placeholder",
    componentId: "sc-32oveo-5"
  })(["&,& input{pointer-events:none;position:absolute;z-index:1;left:0;top:0;width:100%;background-color:transparent;border-color:transparent;font-weight:300;color:", ";}"], daveGrey(0.7)),
  CaptionsContainer: styled.div.withConfig({
    displayName: "theme__CaptionsContainer",
    componentId: "sc-32oveo-6"
  })(["display:flex;flex-direction:column;z-index:1;"]),
  Error: styled(StyledCaption).withConfig({
    displayName: "theme__Error",
    componentId: "sc-32oveo-7"
  })(["color:", ";"], errorText()),
  Hint: styled(StyledCaption).withConfig({
    displayName: "theme__Hint",
    componentId: "sc-32oveo-8"
  })(["color:", ";font-style:italic;"], daveGrey())
};
export default theme;